import { W as WuiEmptyState$1, d as defineCustomElement$1 } from './empty-state.js';

const WuiEmptyState = WuiEmptyState$1;
const defineCustomElement = defineCustomElement$1;

export { WuiEmptyState, defineCustomElement };

//# sourceMappingURL=wui-empty-state.js.map